import { formatDateWithTz } from '@/helpers/tzDate'

export default function getFields(vm) {
  const fields = [
    {
      key: 'vehicleInformation',
      label: 'report.fields.vehicleInformation',
      header: 'vehicleInformation',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'vehicle.vehicle2VGroup',
          label: 'report.fields.vehicleGroup',
          header: 'vehicleGroup',
          filter: true,
          width: 20,
          childOfIndex: 0,
          isTopHead: 1,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.vehicle?.vehicle2Vgroup?.map((val) => val?.vgroup?.name)?.join(', ') ?? '-'
          },
        },
        {
          key: 'vehicle.licensePlate',
          label: 'report.fields.licensePlate',
          header: 'licensePlate',
          filter: true,
          width: 20,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.vehicle?.licensePlate || '-'
          },
        },
        {
          key: 'driver.fullname',
          label: 'report.fields.driver',
          header: 'driver',
          filter: true,
          width: 20,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.driver?.fullname || '-'
          },
        },
      ],
      headerColspan: 3,
    },
    {
      key: 'tripInformation',
      label: 'report.fields.tripInformation',
      header: 'tripInformation',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'startTrip.time',
          label: 'report.fields.startDate',
          header: 'startTime',
          filter: false,
          width: 20,
          childOfIndex: 1,
          isTopHead: 1,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.startTrip?.time
              ? formatDateWithTz(item.startTrip?.time, 'DD MMM YYYY HH:mm')
              : '-'
          },
        },
        {
          key: 'endTrip.time',
          label: 'report.fields.endDate',
          header: 'stopTime',
          filter: false,
          width: 20,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.endTrip?.time
              ? formatDateWithTz(item.endTrip?.time, 'DD MMM YYYY HH:mm')
              : '-'
          },
        },
        {
          key: 'startTrip',
          label: 'report.fields.startLocation',
          header: 'startLocation',
          filter: false,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
        },
        {
          key: 'endTrip',
          label: 'report.fields.stopLocation',
          header: 'stopLocation',
          filter: false,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
        },
        {
          key: 'tripKmMileage',
          label: 'report.fields.totalDistance',
          header: 'tripMileage',
          filter: false,
          width: 20,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.tripKmMileage !== null && item?.tripKmMileage !== undefined
              ? item?.tripKmMileage
              : '-'
          },
        },
        {
          key: 'tripMinuteDuration',
          label: 'report.fields.totalTripDuration',
          header: 'tripDuration',
          filter: false,
          width: 20,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.tripMinuteDuration !== null && item?.tripMinuteDuration !== undefined
              ? item.tripMinuteDuration
              : '-'
          },
        },
        {
          key: 'stopMinuteDuration',
          label: 'report.fields.totalStopDuration',
          header: 'stopDuration',
          filter: false,
          width: 20,
          childOfIndex: 1,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.stopMinuteDuration !== null && item?.stopMinuteDuration
              ? item.stopMinuteDuration
              : '-'
          },
        },
      ],
      headerColspan: 7,
    },
    {
      key: 'vehicleStatus',
      label: 'report.fields.vehicleStatus',
      header: 'vehicleStatus',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'temperature',
          label: 'report.fields.temperature',
          header: 'temperature',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 1,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.temperature !== null && item?.temperature !== undefined
              ? `${item.temperature}°C`
              : '-'
          },
        },
        {
          key: 'fuel',
          label: 'report.fields.fuel',
          header: 'fuel',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.fuel !== null && item?.fuel !== undefined ? item.fuel : '-'
          },
        },
        {
          key: 'isEngineOn',
          label: 'report.fields.engine',
          header: 'engine',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.isEngineOn ? vm.$t(`report.status.on`) : vm.$t('report.status.off')
          },
        },
        {
          key: 'isDoorOpen',
          label: 'report.fields.door',
          header: 'door',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.isDoorOpen ? vm.$t(`report.status.open`) : vm.$t('report.status.close')
          },
        },
        {
          key: 'doorOpenFrequencyOnTrip',
          label: 'report.fields.doorOpenFrequencyOnTrip',
          header: 'openDoorFrequencyInTrip',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.doorOpenFrequencyOnTrip !== null &&
              item?.doorOpenFrequencyOnTrip !== undefined
              ? item.doorOpenFrequencyOnTrip
              : '-'
          },
        },
        {
          key: 'doorOpenFrequencyOnStop',
          label: 'report.fields.doorOpenFrequencyOnStop',
          header: 'openDoorFrequencyAtStopLocation',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.doorOpenFrequencyOnStop !== null &&
              item?.doorOpenFrequencyOnStop !== undefined
              ? item.doorOpenFrequencyOnStop
              : '-'
          },
        },
        {
          key: 'doorOpenDurationOnStop',
          label: 'report.fields.doorOpenDurationOnStop',
          header: 'totalTimeOpenDoorAtStopLocation',
          filter: false,
          width: 20,
          childOfIndex: 2,
          isTopHead: 0,
          isLocked: true,
          headerColspan: 1,
          formatter: (_, __, item) => {
            return item?.doorOpenDurationOnStop !== null &&
              item?.doorOpenDurationOnStop !== undefined
              ? item.doorOpenDurationOnStop
              : '-'
          },
        },
      ],
      headerColspan: 7,
    },
  ]

  fields.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      item.children.forEach((child) => {
        child.label = vm.$t ? vm.$t(child.label) : child.label
      })
    }
    item.label = vm.$t ? vm.$t(item.label) : item.label
  })

  return fields
}
